<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="80px">
      <!-- 学生姓名搜索 -->
      <el-form-item label="姓名" prop="studentName">
        <el-input 
          v-model="queryParams.studentName" 
          placeholder="请输入学生姓名" 
          clearable 
          size="small"
          @keyup.enter.native="handleQuery" 
        />
      </el-form-item>

      <!-- 专业选择搜索 - 从后台获取 -->
      <el-form-item label="专业" prop="majorId">
        <el-select 
          v-model="queryParams.majorId" 
          placeholder="请选择专业" 
          clearable 
          size="small"
          filterable
        >
          <el-option 
            v-for="major in majorOptions" 
            :key="major.majorId" 
            :label="major.majorName" 
            :value="major.majorId" 
            size="small"
          />
        </el-select>
      </el-form-item>

      <!-- 班级选择搜索 - 从后台获取 -->
      <el-form-item label="班级" prop="classId">
        <el-select 
          v-model="queryParams.classId" 
          placeholder="请选择班级" 
          clearable 
          filterable
          size="small"
        >
          <el-option 
            v-for="cls in classOptions" 
            :key="cls.id" 
            :label="cls.className" 
            :value="cls.id" 
          />
        </el-select>
      </el-form-item> <br/>

      <!-- 学制选择搜索
      <el-form-item label="学制" prop="majorYear">
        <el-select 
          v-model="queryParams.majorYear" 
          placeholder="请选择学制" 
          clearable
        >
        <el-option label="半年制" value="半年制" />
        <el-option label="1年制" value="1年制" />
          <el-option label="2年制" value="2年制" />
          <el-option label="3年制" value="3年制" />
        </el-select>
      </el-form-item> -->

      <!-- 更新时间改为年月选择器 -->
     <!-- 更新时间改为年月选择器 -->
<el-form-item label="月份" prop="updateMonth">
  <el-date-picker
    v-model="queryParams.updateMonth"
    type="month"
    value-format="yyyy-MM"
    placeholder="选择年月"
    @change="handleMonthChange"
  />
</el-form-item>

      <!-- 操作按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

     操作按钮区域
    <el-row :gutter="10" class="mb8">
      <!--<el-col :span="1.5">
        <el-button 
          type="success" 
          plain 
          icon="el-icon-edit" 
          size="mini" 
          :disabled="single"
          @click="handleUpdate"
        >
          修改
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button 
          type="danger" 
          plain 
          icon="el-icon-delete" 
          size="mini" 
          :disabled="multiple"
          @click="handleDelete"
        >
          删除
        </el-button>
      </el-col> -->
      <el-col :span="1.5">
        <el-button 
          type="warning" 
          plain 
          icon="el-icon-download" 
          size="mini" 
          @click="handleExport"
        >
          导出
        </el-button>
      </el-col>
      <!-- <right-toolbar 
        :showSearch.sync="showSearch" 
        @queryTable="getList"
      /> -->
    </el-row>

    <!-- 数据表格 -->
    <el-table 
      v-loading="loading" 
      :data="studentList" 
      @selection-change="handleSelectionChange"
      class="table-container"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="编号" align="center" prop="id" />
      <el-table-column label="学生ID" align="center" prop="studentId" />
      <el-table-column label="姓名" align="center" prop="studentName" />
      <el-table-column label="专业" align="center" prop="majorName" />
      <el-table-column label="班级" align="center" prop="className" />
      <el-table-column label="学制" align="center" prop="majorYear">
        <template slot-scope="scope">
          {{ scope.row.majorYear }}
        </template>
      </el-table-column>
      <el-table-column label="当前学分" align="center">
        <template slot-scope="scope">
          <span :style="getCreditStyle(scope.row)">
            {{ scope.row.totalCredits }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" align="center" prop="lastUpdate" width="180">
        <template slot-scope="scope">
          {{ parseTime(scope.row.lastUpdate) }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="150">
        <template slot-scope="scope">
          <el-button 
            size="mini" 
            type="text" 
            icon="el-icon-edit" 
            @click="handleUpdate(scope.row)"
          >
            修改
          </el-button>
          <el-button 
            size="mini" 
            type="text" 
            icon="el-icon-delete" 
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页组件 -->
    <el-pagination 
      background 
      class="pagination-container" 
      v-show="total > 0" 
      :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" 
      :page-size="queryParams.pageSize" 
      layout="total, sizes, prev, pager, next, jumper"
      :total="total" 
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange" 
    />

    <!-- 修改对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="学生姓名" prop="studentName">
          <el-input v-model="form.studentName" disabled />
        </el-form-item>
        <el-form-item label="专业" prop="majorName">
          <el-input v-model="form.majorName" disabled />
        </el-form-item>
        <el-form-item label="班级" prop="className">
          <el-input v-model="form.className" disabled />
        </el-form-item>
        <el-form-item label="学制" prop="majorYear">
          <el-input v-model="form.majorYear" disabled />
        </el-form-item>
        <el-form-item label="当前学分" prop="totalCredits">
          <el-input-number 
            v-model="form.totalCredits" 
            :min="0" 
            :max="200" 
            controls-position="right" 
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="更新日期" prop="lastUpdate">
          <el-date-picker 
            v-model="form.lastUpdate" 
            type="date" 
            value-format="yyyy-MM-dd" 
            placeholder="选择更新日期"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listStudent, getStudent, updateStudent, delStudent } from "@/api/system/student";
import { listMajors } from "@/api/OmdMajors/majors";
import { listClasses } from "@/api/OmdClasses/classes";
import { download } from "@/utils/request";

export default {
  name: "StudentCredit",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 学生学分表格数据
      studentList: [],
      // 专业选项 - 从后台获取
      majorOptions: [],
      // 班级选项 - 从后台获取
      classOptions: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        studentName: null,
        majorId: null,      // 改为专业ID
        classId: null,      // 改为班级ID
        majorYear: null,
        updateMonth: null, // 年月选择
        updateYear: null,  // 年份
        updateMonthValue: null // 月份
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        totalCredits: [
          { required: true, message: "学分不能为空", trigger: "blur" },
          { type: "number", message: "学分必须为数字值" }
        ],
        lastUpdate: [
          { required: true, message: "更新时间不能为空", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.getList();
    this.getMajorList();
    this.getClassList();
  },
  methods: {
    /** 处理年月选择变化 */
    handleMonthChange(value) {
      if (value) {
        const [year, month] = value.split('-');
        this.queryParams.updateYear = year;
        this.queryParams.updateMonthValue = month;
      } else {
        this.queryParams.updateYear = null;
        this.queryParams.updateMonthValue = null;
      }
    },
    /** 根据学制和学分设置样式 */
    getCreditStyle(row) {
      if (!row.totalCredits) return {};
      
      // 半年制学分低于30分
      if (row.majorYear === '半年制' && row.totalCredits < 30) {
        return { color: 'red', fontWeight: 'bold' };
      }
      
      // 一年制学分低于60分
      if (row.majorYear === '1年制' && row.totalCredits < 60) {
        return { color: 'red', fontWeight: 'bold' };
      }
       // 一年制学分低于60分
      if (row.majorYear === '2年制' && row.totalCredits < 90) {
        return { color: 'red', fontWeight: 'bold' };
      }
      
      return {};
    },
    /** 查询学生学分列表 */
    getList() {
      this.loading = true;
      
      // 处理查询参数 - 将年月转换为日期范围
      const params = {
        ...this.queryParams,
        // 分页参数
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
         // 添加年月参数
        updateYear: this.queryParams.updateYear,
        updateMonth: this.queryParams.updateMonthValue
      };
      
      // 如果选择了月份，设置开始和结束日期
      if (this.queryParams.updateMonth) {
        const yearMonth = this.queryParams.updateMonth;
        const [year, month] = yearMonth.split('-');
        const startDate = `${yearMonth}-01`;
        
        // 计算该月的最后一天
        const lastDay = new Date(year, month, 0).getDate();
        const endDate = `${yearMonth}-${lastDay}`;
        
        params.startDate = startDate;
        params.endDate = endDate;
      }
      
      listStudent(params).then(response => {
        this.studentList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    
    /**
     * 获取专业列表
     * @return {void}
     */
    getMajorList() {
      listMajors().then(response => {
        this.majorOptions = response.rows;
      }).catch(error => {
        console.error("获取专业列表失败:", error);
      });
    },

    /**
     * 获取班级列表
     * @return {void}
     */
    getClassList() {
      listClasses().then(response => {
        this.classOptions = response.rows;
      }).catch(error => {
        console.error("获取班级列表失败:", error);
      });
    },
    
    /** 每页条数变化 */
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    
    /** 当前页变化 */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    
    /** 重置按钮操作 */
    resetQuery() {
     
      // 重置表单验证状态
      if (this.$refs.queryForm) {
        this.$refs.queryForm.resetFields();
      }
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        studentName: null,
        majorId: null,
        classId: null,
        majorYear: null,
        updateMonth: null,
        updateYear: null,  // 年份
        updateMonthValue: null // 月份
      };
      this.getList();
    },
     
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids[0];
      getStudent(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改学分信息";
      });
    },
    
    /** 提交表单 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          updateStudent(this.form).then(response => {
            this.$modal.msgSuccess("修改成功");
            this.open = false;
            this.getList();
            console.log(response);
          });
        }
      });
    },
    
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除选中的学生学分记录？').then(() => {
        return delStudent(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    
    /** 导出按钮操作 */
   /**
        * 导出按钮操作
        */
       handleExport() {
         // const queryParams = this.queryParams;
         this.$confirm('是否确认导出所有作品数据项?', "警告", {
           confirmButtonText: "确定",
           cancelButtonText: "取消",
           type: "warning"
         }).then(() => {
           download('/system/student/export', {
             ...this.queryParams
           }, `学生学分_${new Date().toLocaleDateString()}.xlsx`)
         }).then(response => {
           this.download(response.msg);
         }).catch(() => { });
       },
    
    // 表单重置
    reset() {
      this.form = {
        id: null,
        studentId: null,
        totalCredits: null,
        studentName:null,
        majorId: null,
        classId: null,
        majorYear: null,
        updateMonth: null,
        updateYear: null,  // 年份
        updateMonthValue: null // 月份
      };
      // 重置表单验证状态
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    
    // 日期格式化
    parseTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    }
  }
};
</script>

<style scoped>
/* 使用与WorksMain相同的样式 */
.app-container {
  padding: 20px;
}

/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}

/* 表格头部 */
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

::v-deep .el-pager li:hover {
  color: var(--primary-color) !important;
}

::v-deep .el-button--primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

::v-deep .el-button--primary:hover {
  background-color: #d6336c;
  border-color: #d6336c;
}

/* 搜索表单样式 */
.el-form-item {
  margin-bottom: 15px;
}

/* 分页容器 */
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>